module.exports = __webpack_public_path__ + "media/images/lb/552-5281bf7b34f84acd98ccbb5d3d7e3a14.svg";